<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sort`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.38 28.456a.278.278 0 01.213-.456h18.814c.235 0 .364.275.213.456l-9.108 10.93a.667.667 0 01-1.024 0l-9.108-10.93zM14.38 19.544a.278.278 0 00.213.456h18.814a.278.278 0 00.213-.456l-9.108-10.93a.667.667 0 00-1.024 0l-9.108 10.93z"/></svg>
</template>
<script>

export default {
  name: 'IconSort',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
